<template>
  <div class="homePage">
    <!-- 初始化弹窗 -->
    <transition name="alert">
      <Alerttwo v-show="bookingBoxAlert">
        <div class="fixed-booking">
          <bookingBox type="fixed" :inviteMa="inviteMa" />
          <img
            class="toast_btn"
            src="../assets/images/toast_btn.png"
            alt=""
            @click="bookingBoxAlert = false"
          />
        </div>
      </Alerttwo>
    </transition>
    <!-- <Loading v-if="loading_show" @loadingShow="loadingShow"></Loading> -->
    <img src="../assets/images/BG.jpg" alt="" class="BG" />
    <div class="other-content">
      <partone 
        ref="One" :pageInfo="pageInfo"></partone>
      <pageTwo
        ref="Two"
        :allCode="allCode"
        :pageInfo="pageInfo"
        :inviteMa="inviteMa"
      ></pageTwo>
      <pageThree
        :allCode="allCode"
        @dialog="dialog"
        @dialogresult="dialogresult"
        ref="Three"
      ></pageThree>
      <pageFour ref="Four" :allCode="allCode"></pageFour>
      <pageFive ref="Five" :pageInfo="pageInfo"></pageFive>
      <pageSix></pageSix>
      <pageSeven></pageSeven>
    </div>
    <dialopage
      v-if="dialog_show"
      :questionList="questionList"
      @page="pageAnswer"
      @qvxiao="qvxiao"
    ></dialopage>
    <dialoresult
      v-if="showresult"
      :allCode="allCode"
      @closePop="closePop"
    ></dialoresult>
    <!-- 邀请好友弹窗 -->
    <transition name="alert">
      <Alert v-if="inviteAlert" @close="inviteAlert = false">
        <div class="centerbox">
          <div class="invite-box">
            <inviteAlert :allCode="allCode" />
          </div>
          <img
            @click="inviteAlert = false"
            class="attentionbox-close"
            src="../assets/images/toast_btn.png"
            alt=""
          />
        </div>
      </Alert>
    </transition>
    <!-- 小游戏测试成功  -->
    <transition name="alert">
      <Alert v-if="test_p">
        <div class="centerbox">
          <div class="test">
            <testprize :testMa="testMa" />
          </div>
          <img
            @click="test_p = false"
            class="test-close"
            src="../assets/images/toast_btn.png"
            alt=""
          />
        </div>
      </Alert>
    </transition>
    <!-- 预约成功 商店引导窗口 -->
    <transition name="alert">
      <Alert v-if="yy_success">
        <div class="centerbox">
          <div class="success">
            <yysuccess :pageInfo="pageInfo" />
          </div>
          <img
            @click="yy_success = false"
            class="attentionbox-close"
            src="../assets/images/toast_btn.png"
            alt=""
          />
        </div>
      </Alert>
    </transition>
    <!-- 注意事项 -->
    <transition name="alert">
      <Alert v-if="attentionAlert">
        <div class="centerbox">
          <div class="attentionbox" @touchmove.stop>
            <p class="Active_title">活動說明</p>
            <div class="Active_content" v-html="formatWord(tips)"></div>
          </div>
          <img
            @click="attentionAlert = false"
            class="attentionbox-close"
            src="../assets/images/toast_btn.png"
            alt=""
          />
        </div>
      </Alert>
    </transition>
    <!-- 奖励弹窗 -->
    <transition name="alert">
      <Alertthree v-if="prizeList" @close="prizeList = false" type="pri">
        <div class="prize">
          <div class="list">
            <div
              class="listItem dl"
              v-for="(item, index) in pList"
              :key="index"
            >
              <input
                type="text"
                disabled
                class="itemLeft"
                name=""
                id=""
                :value="item.name"
              />
              <input
                type="text"
                class="itemMid"
                name=""
                :value="item.xh"
                id=""
                ref="code"
              />
              <div class="copy_btn" @click="copy(index)"></div>
            </div>
          </div>
        </div>
      </Alertthree>
    </transition>
    <!-- 提示弹窗 -->
    <transition name="alert">
      <Alert v-if="tipsAlert">
        <div class="centerbox">
          <div class="tips">
            <p v-html="tips" />
          </div>
          <img
            @click="tipsAlert = false"
            class="tips-close"
            src="../assets/images/toast_btn.png"
            alt=""
          />
        </div>
      </Alert>
    </transition>
    <!-- 跳转商品回来后的弹窗-->
    <transition name="alert">
      <Alert v-if="Show">
        <div class="albox">
          <div class="backShopalert">
            <div class="imgbox">
              <img
                src="../assets/images/fbzan.png"
                alt=""
                class="politeness"
                @click="openfb"
              />
              <img
                @click="closeAlbox"
                class="albox-close"
                src="../assets/images/toast_btn.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </Alert>
    </transition>
  </div>
</template>

<script>
// import Loading from "../components/loading.vue";
import Alerttwo from "../components/init-alert.vue";
import bookingBox from "../components/booking.vue";
import yysuccess from "../components/yy_success.vue";
import testprize from "../components/test_prize.vue";
import inviteAlert from "../components/invite_alert.vue";
import partone from "./partone.vue";
import pageTwo from "./pageTwo.vue";
import pageThree from "./pageThree.vue";
import pageFour from "./pageFour.vue";
import pageFive from "./pageFive.vue";
import pageSix from "./pageSix.vue";
import pageSeven from "./pageSeven.vue";
import Alert from "../components/alert.vue";
import Alertthree from "../components/prize-alert.vue";
import dialoresult from "../components/dialog_components/result.vue";
import dialopage from "../components/dialog_components/page.vue";
import {
  info,
  pageInfo,
  codes,
  question,
  answer,
  testreward,
} from "@/js/api.js";
export default {
  name: "homePage",
  data() {
    return {
      // loading_show: false,
      index_show: true,
      tipsAlert: false,
      dialog_show: false,
      tips: "",
      phoneData: null,
      pageInfo: {},
      allCode: {
        inviteCode: "",
        inviteCount: "",
        isFbLike: "",
        isStore: "",
        isShare: "",
        people: "",
      },
      bookingBoxAlert: false,
      prizeList: false,
      pList: [],
      showresult: false,
      questionList: [],
      inviteMa: "", //邀请码
      attentionAlert: false,
      yy_success: false,
      test_p: false,
      testMa: "",
      prizeOpenli: true,
      testResult: false,
      inviteAlert: false,
      Show: false,
      backShow: this.$util.getItem("backShow"),
      backNum: this.$util.getItem("backShowNum"),
    };
  },
  // Loading,
  components: {
    Alerttwo,
    partone,
    pageTwo,
    pageThree,
    pageFour,
    pageFive,
    pageSix,
    pageSeven,
    Alert,
    Alertthree,
    dialopage,
    dialoresult,
    bookingBox,
    yysuccess,
    testprize,
    inviteAlert,
  },
  created() {
    let data = this.$util.getToken();
    if (data) {
      this.bookingBoxAlert = false;
    }
    this.inviteMa = this.$route.query.f;
    // this.$util.setItem("iostype", false);
  },
  mounted() {
    //初始化
    let phoneData = this.$util.getToken();
    this.phoneData = phoneData;
    this.pageInit();
    this.getMinfo();
    // this.backshowAlter();
    // document.addEventListener("visibilitychange", () => {
    //   let state = document.visibilityState;
    //   // if (state == "hidden") {
    //   //   alert("用户离开了");
    //   // }
    //   if (state == "visible" && this.backNum == 1) {
    //     this.Show = true;
    //   }
    // });
    this.$bus.$on("num", (res) => {
      this.backNum = res
    });
    this.$bus.$on("tips", (res, op) => {
      this.openTips(res, op);
    });
    this.$bus.$on("reGetMinfo", (type, url) => {
      this.phoneData = this.$util.getToken();
      this.getMinfo(type, url);
    });
    this.$bus.$on("bookingAlert", () => {
      this.bookingBoxAlert = false;
    });
    this.$bus.$on("prizeOpen", () => {
      if (this.prizeOpenli) {
        this.checkCondition();
      } else {
        this.prizeList = true;
      }
    });
    this.$bus.$on("inviteSC", () => {
      this.inviteAlert = true;
    });
  },

  methods: {
    closeAlbox() {
      this.Show = false;
      this.$util.setItem("backShow", false);
      this.$util.setItem("backShowNum", this.backNum + 1);
      this.$bus.$emit("num2", this.backNum + 1);
    },
    openfb() {
      this.$xmlog.fbLike(() => {
        window.open("https://www.facebook.com/XM.DXZ");
      });
    },
    // backshowAlter() {
    //   if (this.backNum === 1 && this.backShow) {
    //     this.Show = true;
    //   }
    // },
    formatWord(val) {
      return val.replace(/\n/g, "<br>");
    },
    checkCondition() {
      // let phoneData = this.$util.getToken();
      if (this.phoneData) {
        let data = this.phoneData.token;
        codes(data).then((res) => {
          if (res.code === 0) {
            for (const key in res.data.codes) {
              let a = {};
              a.name = key;
              a.xh = res.data.codes[key];
              this.pList.push(a);
            }
            console.log(this.pList);
            this.prizeList = true;
            this.prizeOpenli = false;
            // this.$bus.$emit("tips", "奖励记录");
          } else {
            this.$bus.$emit("tips", res.msg);
          }
        });
      } else {
        // alert("請先預約");
        this.$bus.$emit("tips", "請先預約");
        return;
      }
    },
    copy(index) {
      let input = document.createElement("input");
      let content = this.$refs.code[index]._value;
      input.value = content;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.openTips("複製成功");
      document.body.removeChild("input");
    },
    async pageInit() {
      await pageInfo().then((res) => {
        this.pageInfo = res.data;
        this.$refs.One.$emit("pageone", this.pageInfo);
        this.$refs.Five.$emit("pagefive", res.data.people);
      });
    },
    pageAnswer(msg) {
      //答案
      let token = this.$util.getToken().token;
      answer(msg, token).then((res) => {
        console.log(res);
        if (res.code !== 0) {
          // alert(res.data.msg);
          this.$bus.$emit("tips", res.data.msg);
        } else {
          this.dialog_show = false;
          this.showresult = true;
          this.$util.setItem("resultBG", {
            tagId: res.data.tagId,
          });
        }
      });
    },
    qvxiao() {
      this.dialog_show = false;
    },
    closePop() {
      this.showresult = false;
      if (this.testResult) {
        return;
      } else {
        this.testreward();
        this.testResult = true; //不能
      }
    },
    testreward() {
      let data = this.phoneData.token;
      testreward(data).then((res) => {
        // console.log(res);
        this.testMa = res.data.code;
        this.test_p = true;
        // this.$bus.$emit("tips", res.data.code);
      });
    },
    dialogresult() {
      this.showresult = true;
    },
    dialog(value) {
      //题目
      if (value) {
        question().then((res) => {
          this.questionList = res.reverse();
        });
      }
      this.dialog_show = true;
    },
    // loadingShow() {
    //   this.loading_show = false;
    //   this.index_show = true;
    // },
    openTips(msg, op) {
      if (op == "attention") {
        this.attentionAlert = true;
      } else if (op == "yyss") {
        this.yy_success = true;
      } else {
        this.tipsAlert = true;
      }
      this.tips = msg;
    },
    getMinfo(type = void 0, url = void 0) {
      if (this.phoneData !== null) {
        //请求 用户信息
        let data = this.$util.getToken().token;
        info(data).then((res) => {
          if (res.code === 1002) {
            this.$util.removeItem("dxzPhone");
            return;
          } else {
            this.allCode = res.data;
            // console.log(this.allCode, "===============");
            this.$refs.Four.$emit(
              "pagefour",
              res.data.inviteCount,
              res.data.tagId
            );
            this.$refs.Two.$emit("pagetwo", res.data);
            this.$refs.Five.$emit("pagefive", res.data.people);
            if (res.data.tagId !== 0) {
              //如果已经测试过，则不能再测试了！
              this.$refs.Three.$emit("pagethree", res.data.tagId);
              this.$util.setItem("resultBG", {
                tagId: res.data.tagId,
              });
            }
            if (url != void 0) {
              console.log(url, "url");
              // log(type, url);
            }
            if (typeof type == "function") {
              type();
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.homePage {
  width: 100%;
  overflow: hidden;
  height: 100%;
  // background: url("../assets/images/BG.png") no-repeat;
  background-size: 100% auto;
  position: relative;
  .BG {
    width: 100%;
  }
  .other-content {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .centerbox {
    width: 7.5rem;
    height: 7.3rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .tips {
      padding: 1.5rem 1rem 1rem 1.1rem;
      text-align: center;
      width: 7.5rem;
      height: 7.5rem;
      background-size: 80% 80%;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("../assets/images/tip.png");
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-size: 0.3rem;
        color: #25a3df;
        font-weight: 900;
        font-family: wryhBold;
      }
    }
    .tips-close {
      position: absolute;
      right: 15%;
      top: 8%;
      cursor: pointer;
      width: 0.82rem;
      height: 0.82rem;
    }
    .attentionbox {
      padding: 1rem 0.9rem 1rem 1.1rem;
      text-align: center;
      width: 7.5rem;
      background-size: 100%;
      background-repeat: no-repeat;
      background-image: url("../assets/images/tip.png");
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      .Active_title {
        font-weight: bold;
        font-size: 0.3rem;
        color: #003636;
        margin-bottom: 0.5rem;
      }
      .Active_content {
        font-size: 0.2rem;
        font-family: medium;
        text-align: left;
        line-height: 0.4rem;
        overflow-y: scroll;
        height: 4.5rem;
      }
    }
    .attentionbox-close {
      position: absolute;
      right: 9%;
      top: 0%;
      cursor: pointer;
      width: 0.82rem;
      height: 0.82rem;
    }
    .success {
      width: 7.5rem;
      height: 7.3rem;
      background-size: 100%;
      background-repeat: no-repeat;
      background-image: url("../assets/images/kuang3.png");
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      padding: 2.1rem 1rem 1.5rem 1rem;
      text-align: center;
    }
    .test {
      width: 7.5rem;
      height: 7.5rem;
      background-size: 80% 80%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../assets/images/tip.png");
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      padding:1.5rem 1.5rem 1rem 1.6rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .test-close {
      position: absolute;
      right: 15%;
      top: 7%;
      cursor: pointer;
      width: 0.82rem;
      height: 0.82rem;
    }
    .invite-box {
      width: 100%;
      height: 100%;
      background: url("../assets/images/kuang4.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      padding: 3.1rem 1.4rem 0 1.4rem;
      font-size: 0.2rem;
      font-family: Source Han Serif CN;
    }
  }
  .albox {
    width: 7.5rem;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url("../assets/images/gift_bg.png");
    .backShopalert {
      position: relative;
      width: 7.5rem;
      height: 100%;
      background: url("../assets/images/giftImg.png") no-repeat;
      background-size: 100% auto;
      background-position: center;
      .imgbox {
        width: 100%;
        height: 13rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .politeness {
          position: absolute;
          bottom: 1rem;
          left: 50%;
          transform: translateX(-50%);
          width: 3rem;
          height: 1.27rem;
          margin: 0 auto;
          cursor: pointer;
        }
        .albox-close {
          position: absolute;
          right: 5%;
          top: 9%;
          cursor: pointer;
          width: 0.82rem;
          height: 0.82rem;
        }
      }
    }
  }
  .fixed-booking {
    width: 7rem;
    height: 9rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .toast_btn {
      width: 1rem;
      height: 1rem;
      position: absolute;
      top: 5%;
      right: 7%;
      cursor: pointer;
      // transform: translateX(-50%);
    }
  }
  .prize {
    background: url("@/assets/images/tip.png") no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100%;
    padding: 1.1rem 0.8rem 1rem 1.1rem;
    .list {
      width: 100%;
      height: 5rem;
      overflow: scroll;
      .listItem {
        .itemLeft {
          text-align: center;
          padding: 0.1rem;
          width: 1.4rem;
          margin-right: 0.2rem;
          background: url("../assets/images/page1/fill.png") no-repeat;
          background-size: 100% 100%;
          color: #fff;
          height: 0.4rem;
          // line-height: 1.4rem;
          border: none;
          line-height: normal;
        }
        .itemMid {
          padding: 0.1rem;
          text-align: center;
          background: url("../assets/images/page1/fill.png") no-repeat;
          background-size: 100% 100%;
          width: 1.4rem;
          color: #fff;
          height: 0.4rem;
          // line-height: 1.4rem;
          border: none;
          line-height: normal;
        }
        .copy_btn {
          background: url("@/assets/images/page1/copy_btn.png") no-repeat;
          background-size: 100% 100%;
          width: 1.6rem;
          height: 0.6rem;
          cursor: pointer;
          margin-top: 0.1rem;
        }
      }
    }
  }
  .zzz {
    overflow: hidden;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 50%;
    max-width: 7.5rem;
    transform: translateX(-50%);
    z-index: 99;
    .bbb {
      width: 100%;
      height: 100%;
    }
    .xxx {
      position: absolute;
      top: 0rem;
      right: 0rem;
      width: 50%;
      height: 100%;
      z-index: 1;
      background: skyblue;
    }
  }
}
</style>